import {Action} from '@ngrx/store';
import {LoginRequest, LoginResponse} from '../models/auth';
import {ErrorPayload} from '../models/general';

export enum AuthActionTypes {
  Login = '[Auth] Login',
  LoginComplete = '[Auth] Login Complete',
  LoginError = '[Auth] Login Error',
  Logout = '[Auth] Logout',
  LogoutSuccess = '[Auth] Logout Success'
}

export class Login implements Action {
  readonly type = AuthActionTypes.Login;

  constructor(public payload: LoginRequest) {
  }
}

export class LoginComplete implements Action {
  readonly type = AuthActionTypes.LoginComplete;

  constructor(public payload: LoginResponse) {
  }
}

export class LoginError implements Action {
  readonly type = AuthActionTypes.LoginError;

  constructor(public payload: ErrorPayload) {
  }
}

export class Logout implements Action {
  readonly type = AuthActionTypes.Logout;
}

export class LogoutSuccess implements Action {
  readonly type = AuthActionTypes.LogoutSuccess;
}

export type AuthActions =
  | Login
  | LoginComplete
  | LoginError
  | Logout
  | LogoutSuccess;
